import { createElement } from 'react';
import { b as __rest, a8 as LinkText$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var LinkText = function LinkText(_a) {
  var props = __rest(_a, ["iconBrand"]);
  return /*#__PURE__*/createElement(LinkText$1, __assign({
    iconBrand: "uq-ec-"
  }, props));
};
LinkText.displayName = 'LinkText';

export { LinkText };
